import { Redirect } from "react-router-dom";
import { checkUser, getUserData } from "helpers/Session";
import Icon from "@material-tailwind/react/Icon";

const Dashboard = () => {
	const userData = getUserData();
	const firstName = (userData.nama || "Admin").split(" ")[0];
	const kementerian = userData.kementerian?.singkatan || "-";

	return (
		<>
			{!checkUser() ? (
				<Redirect to={"/"} />
			) : (
				<div className="min-h-screen bg-background">
					{/* Hero Section */}
					<div className="bg-primary pt-12 pb-24 px-6 md:px-12 rounded-b-3xl relative overflow-hidden">
						<div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'24\\' height=\\'24\\' viewBox=\\'0 0 24 24\\'%3E%3Cg fill=\\'%23ffffff\\' fill-opacity=\\'0.05\\'%3E%3Cpolygon fill-rule=\\'evenodd\\' points=\\'8 4 12 6 8 8 6 12 4 8 0 6 4 4 6 0 8 4\\'/%3E%3C/g%3E%3C/svg%3E')] opacity-30" />
						<div className="relative z-10 max-w-7xl mx-auto">
							<h1 className="font-bold text-3xl md:text-4xl text-white tracking-tight mb-2">
								Selamat Datang, <span className="text-secondary">{firstName}</span>!
							</h1>
							<p className="text-primary-light text-lg">
								Dashboard Admin - Kementerian {kementerian}
							</p>
						</div>
					</div>

					{/* Stats / Quick Actions Area */}
					<div className="px-6 md:px-12 -mt-12 relative z-20 pb-16">
						<div className="max-w-7xl mx-auto">
							<div className="glass-card p-8">
								<div className="flex items-center gap-4 mb-6">
									<div className="bg-primary/10 p-3 rounded-xl text-primary">
										<Icon name="info" size="2xl" />
									</div>
									<div>
										<h2 className="text-xl font-bold text-text-heading">Informasi Sistem</h2>
										<p className="text-text-muted text-sm">Status saat ini</p>
									</div>
								</div>
								
								<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
									<div className="bg-background border border-slate-100 p-6 rounded-2xl flex flex-col justify-center items-center text-center transition-all duration-300 hover:shadow-soft">
										<Icon name="person" size="3xl" color="gray" />
										<h3 className="mt-4 font-semibold text-text-heading">Total Anggota</h3>
										<p className="text-text-muted text-sm mt-1">Kelola data anggota SGE</p>
									</div>
									<div className="bg-background border border-slate-100 p-6 rounded-2xl flex flex-col justify-center items-center text-center transition-all duration-300 hover:shadow-soft">
										<Icon name="groups" size="3xl" color="gray" />
										<h3 className="mt-4 font-semibold text-text-heading">Program Kerja</h3>
										<p className="text-text-muted text-sm mt-1">Pantau kegiatan berjalan</p>
									</div>
									<div className="bg-background border border-slate-100 p-6 rounded-2xl flex flex-col justify-center items-center text-center transition-all duration-300 hover:shadow-soft">
										<Icon name="feed" size="3xl" color="gray" />
										<h3 className="mt-4 font-semibold text-text-heading">Penilaian Rapor</h3>
										<p className="text-text-muted text-sm mt-1">Evaluasi kinerja staf</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Dashboard;
